module.exports = __webpack_public_path__ + "img/card_diamond@2x.dc898415.png";